export enum EstimatesCleverTapEvents {
  webEstimateHistoryPanel = 'Web_Estimate_History_Panel',
  webEnterNotesTextBoxClicked = 'Web_Enter_Notes_Text_Box_Clicked',
  webEstimateCreatePageView = 'Web_Estimate_Create_Page_View',
  webEstimateLeadSourcePageView = 'Web_Estimate_Lead_Source_Page_View',
  webEstimateEditPageView = 'Web_Estimate_Edit_Page_View',
  webCreateEstimateNotePage = 'Web_Create_Estimate_Note_Page',
  webImageViewerOpened = 'Web_Image_Viewer_Opened',
  webDeleteEstimateConfirmation = 'Web_Delete_Estimate_Confirmation',
  webAllEstimatesPageView = 'Web_All_Estimates_Page_View',
  webEstimatesRejectedPageView = 'Web_Estimates_Rejected_Page_View',
  webEstimatesAcceptedPageView = 'Web_Estimates_Accepted_Page_View',
  webEstimatesPendingPageView = 'Web_Estimates_Pending_Page_View',
  webEstimatesCreateEstimateSave = 'Web_Estimate_Create_Estimate_Save'
}
